<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="$route.path"
            :collapse="collapse"
            background-color="#324157"
            text-color="#fff"
            active-text-color="#20a0ff"
            unique-opened
            router
        >
            <template v-for="item in menus">
                <template v-if="item.Children && item.Children.length > 0">
                    <el-submenu :index="item.ViewPath" :key="item.ViewPath">
                        <template #title>
                            <i :class="item.Icon"></i>
                            <span>{{ item.MenuName }}</span>
                        </template>
                        <template v-for="subItem in item.Children">
                            <el-submenu
                                v-if="subItem.Children && subItem.Children.length > 0"
                                :index="subItem.ViewPath"
                                :key="subItem.ViewPath"
                            >
                                <template #title>{{ subItem.MenuName }}</template>
                                <el-menu-item
                                    v-for="(threeItem, i) in subItem.Children"
                                    :key="i"
                                    :index="threeItem.ViewPath"
                                >{{ threeItem.MenuName }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :index="subItem.ViewPath"
                                :key="subItem.ViewPath"
                            >
                                <i :class="subItem.Icon"></i>
                                <template #title>{{ subItem.MenuName }}</template>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.ViewPath" :key="item.ViewPath">
                        <i :class="item.Icon"></i>
                        <template #title>{{ item.MenuName }}</template>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
// import bus from "../common/bus";
export default {
    data() {
        return {
            menus:[]
        };
    },
    methods:{
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace("/", "");
        },
        collapse(){
            return this.$store.state.collapse
        },
    },
    watch: {
    },
    mounted(){
    },
    activated(){
        if(localStorage.getItem("routers")){
          this.menus = JSON.parse(localStorage.getItem("routers"))
        }
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}
.sidebar > ul {
    height: 100%;
}

.sidebar .is-active{
    background-color: rgb(40,52,70)!important;
}

</style>
